import React, { useEffect } from 'react';

const UserLayout = ({ children }) => {
  useEffect(() => {
    document.body.classList.add('background');
    document.body.classList.add('no-footer');

    return () => {
      document.body.classList.remove('background');
      document.body.classList.remove('no-footer');
    };
  }, []);

  return (
    <div className="rlogin-background" style={{
     display:"flex"
    }}>
        <div className="rlogin-container" style={{
          display: "flex",
          alignContent: 'center',
          justifyContent: 'center',
          alignItems: 'center'
        }}>{children}</div>
    </div>
  );
};

export default UserLayout;
